import { render, staticRenderFns } from "./associatedBusiness.vue?vue&type=template&id=056060f8&scoped=true&"
import script from "./associatedBusiness.vue?vue&type=script&lang=js&"
export * from "./associatedBusiness.vue?vue&type=script&lang=js&"
import style0 from "./associatedBusiness.vue?vue&type=style&index=0&id=056060f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056060f8",
  null
  
)

export default component.exports